import DetailFieldsCard, { DetailField } from '@/components/DetailFieldsCard';
import { getStatusInfo } from '@/utils/submissions';

interface StudyDetailsCardProps {
  submission: {
    status?: string;
    protocol_number?: string;
    protocol_title?: string;
    pi_name?: string;
    owner?: {
      sponsor_name?: string;
      cro_name?: string;
    };
    submission_template?: {
      variant?: string;
      category?: string;
      sub_category?: string;
    };
  };
}

const StudyDetailsCard = ({ submission }: StudyDetailsCardProps) => {
  const statusInfo = submission.status
    ? getStatusInfo(submission.status)
    : null;

  const fields: DetailField[] = [
    { label: 'Protocol Number', value: submission.protocol_number },
    {
      label: 'Status',
      render: statusInfo ? (
        <div className="inline-flex items-center gap-2">
          <div
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: statusInfo.color }}
          />
          <span className="text-gray-900">{statusInfo.label}</span>
        </div>
      ) : undefined,
    },
    { label: 'Sponsor', value: submission.study?.sponsor_name },
    { label: 'CRO', value: submission.study?.cro_name },
    { label: 'Variant', value: submission.submission_template?.variant },
    { label: 'Protocol Title', value: submission.protocol_title },
    { label: 'PI Name', value: submission.pi_name },
    { label: 'Category', value: submission.submission_template?.category },
    {
      label: 'Sub-Category',
      value: submission.submission_template?.sub_category,
    },
  ];

  return <DetailFieldsCard title="Study Details" fields={fields} />;
};

export default StudyDetailsCard;
